import styled from 'styled-components';

import {textSizes} from '@stencil/build-theme';
import {LargeSectionHeader} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const PropertyHighlightsWrapper = styled.div(
  props => `
  width: 100%;
  margin: 0 auto;
  max-width:120rem;
  background-color: ${props.theme.colors.goWhite.base};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  margin-top: 2rem;
`,
);

export const PropertyHighlightsHeader = styled(LargeSectionHeader)(
  props => `
  border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge};
  border-bottom-left-radius:0;
  border-bottom-right-radius:0;
`,
);

export const PropertyHighlightsDesc = styled.p`
  ${textSizes.MediumW1}
  color: #46484D;
  margin-bottom: 2rem;
`;

export const PropertyHighlightsBody = styled.div`
  padding: 1.6rem 2.4rem 2.4rem;
`;

export const FeatureList = styled.ul`
  list-style: none;
  display: flex;
  gap: 1.6rem;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;

  li {
    width: 380px;
    flex: none;
  }
`;
